import React from "react";
import { useDispatch, useSelector } from "react-redux";
import DialogComponent from "../../blue-library/elements/dialogComponent";
import { ALERT_SOURCE_TO_PATH_MAP } from "../qnb-const";
import PopupScreen from "./popupScreen";
var GlobalDialog = function GlobalDialog() {
    var dispatch = useDispatch();
    var isShow = useSelector(function (state) { return state.ui.dialogOpen; });
    var setOpen = function setOpen(close) { dispatch({ type: "ui/setDialogOpen", payload: { status: close } }); };
    var errorCode = useSelector(function (state) { return state.ui.errorCode; });
    var source = useSelector(function (state) { return state.ui.errorData; });
    var selectUi = function selectUi(state) { return state.ui; };
    var _useSelector = useSelector(selectUi), currentDialog = _useSelector.currentDialog;
    var getGtmPopupType = function getGtmPopupType() {
        switch (currentDialog) {
            case "planDetails": return "/pop-up/plan-details";
            case "benefit": return "/pop-up/benefit-illustration";
            case "OTP": return "/pop-up/mobile-verification";
            default: break;
        } // Use ALERT_SOURCE_TO_PATH_MAP for specific sources if available
        if (source && ALERT_SOURCE_TO_PATH_MAP[source]) {
            return ALERT_SOURCE_TO_PATH_MAP[source];
        }
        return undefined;
    };
    return /*#__PURE__*/ React.createElement(DialogComponent, { isShow: isShow, setOpen: setOpen, errorCode: errorCode, gtmPopupType: getGtmPopupType() }, /*#__PURE__*/ React.createElement("div", { className: "p-8 pointer-events-none" }, /*#__PURE__*/ React.createElement("div", { className: "pointer-events-auto" }, /*#__PURE__*/ React.createElement(PopupScreen, null))));
};
export default GlobalDialog;
